var debounce = require('debounce');

module.exports = function(h) {
    let _this = this;
    let query = _this.query;

    return classes => {
        let search =
            _this.source == 'client'
                ? _this.search.bind(_this, _this.data)
                : _this.serverSearch.bind(_this);
        let debouncedSearch = debounce(search, 500);

        return (
            <div
                style={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
                <div style={{ position: 'relative', flexGrow: 1 }}>
                    <input
                        class={`${classes.input} ${classes.small}`}
                        type="text"
                        value={query}
                        placeholder={_this.display('filterPlaceholder')}
                        onChange={e => (query = e.target.value)}
                        onKeydown={e => {
                            if (e.key === 'Enter') {
                                debouncedSearch(e);
                            }
                        }}
                        style={{
                            paddingRight: '30px',
                            width: '100%',
                        }}
                    />
                    <i
                        class="glyphicon glyphicon-search"
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            fontSize: '1em',
                            color: '#999',
                        }}
                    />
                </div>
                <button
                    class="btn btn-fw white"
                    style={{ marginLeft: '10px' }}
                    onClick={e => {
                        e.target.value = query;
                        debouncedSearch(e);
                    }}
                >
                    Search
                </button>
            </div>
        );
    };
};
